import React from 'react'
import {Input} from 'reactstrap';
import _padStart from 'lodash/padStart';


export default class SelectHour extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            start_hour: this.props.start_hour || '14:00'
        }
    }


    getSelection = () => {
        return this.state.start_hour
    }


    renderHours = () => {
        let result = []
        let minutes = ['00', '15', '30', '45']
        for (let i = 0; i <= 23; i++) {
            result = result.concat(minutes.map((m) => {
                let h = _padStart((i.toString() + ':' + m),5, '0')
                return (
                    <option key={h} value={h}>{h}</option>
                )
            }))
        }
        return result
    }

    updateHours = (selected) => {
        this.setState(selected)
    }

    render() {
        return (
            <div className={'row '}>
                <div className={'col'}>
                    <small>{this.props.t.pick_hour}</small>
                    <Input type="select" name="start_hour" id="start_hour"
                           defaultValue={this.state.start_hour}
                           onChange={(selected) => {
                               this.updateHours({start_hour: selected.currentTarget.value})
                           }}>
                        {this.renderHours()}
                    </Input>
                </div>
            </div>
        )
    }
}